import { createFileRoute } from '@tanstack/react-router'
import { PropertyEditPage } from '../../../../components/PropertyEditPage'

export const Route = createFileRoute('/$org/properties/$propertyUid/edit')({
  component: EditProperty,
})

function EditProperty() {
  return <PropertyEditPage />
}